export default __webpack_public_path__ + "static/media/login_password.140b8aac.svg";